export const countItems = <T>(items: T[], predicate: (item: T) => boolean) =>
  items.reduce((count, item) => count + (predicate(item) ? 1 : 0), 0)
